export const urlencodeFormData = (fd) => {
  var s = '';
  function encode(s){ return encodeURIComponent(s).replace(/%20/g,'+'); }
  for(var pair of fd.entries()){
      if(typeof pair[1]=='string'){
          s += (s?'&':'') + encode(pair[0])+'='+encode(pair[1]);
      }
  }
  return s;
}


// WEBPACK FOOTER //
// ./src/utils/formData.js